import React from "react";
import "./style.scss";
import QRCode from "react-qr-code";
import useDesktopSize from "../../utils/hooks/useDesktopSize";

interface IProps {
  trhId: string;
  name: string;
  customDesktopSize?: number;
  customMobileSize?: number;
}

const QrCodeModal: React.FC<IProps> = ({ name, trhId, customDesktopSize, customMobileSize }: IProps) => {
  const isDesktop = useDesktopSize();
  return (
    <>
      <div className="qr-code-modal">
        {trhId && (
          <QRCode
            value={trhId}
            size={isDesktop ? customDesktopSize || 250 : customMobileSize || 120}
            bgColor="#ffffff"
          />
        )}
        <b className="qr-name">{name}</b>
        <span className="qr-code-text">{trhId}</span>
      </div>
    </>
  );
};

export default QrCodeModal;
